/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field-infix{display:block!important;width:160px!important}.date .mat-form-field{width:300px!important}"];
export { styles as styles };
